
import HeroSection from './components/HeroSection';
import RecommendedArticles from './components/RecommendedArticles';
import TopCryptoExchanges from './components/TopCryptoExchanges';
import ServicesSection from './components/ServicesSection';
import LatestArticles from './components/LatestArticles';
// import NewsletterSection from './components/NewsletterSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <RecommendedArticles />
      <TopCryptoExchanges />
      <ServicesSection />
      <LatestArticles />
      {/* <NewsletterSection /> */}
    </div>
  );
}
